import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {WarehouseProduct} from "../../../shared/interface/warehouse-product";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Profile} from "../../../shared/interface/profile";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {WarehouseService} from "../../../shared/services/warehouse.service";
import {takeUntil} from "rxjs/operators";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {FormBuilder, FormControl} from "@angular/forms";

@Component({
  selector: 'app-warehouse-product-details-view',
  templateUrl: './warehouse-product-details-view.component.html',
  styleUrls: ['./warehouse-product-details-view.component.scss']
})
export class WarehouseProductDetailsViewComponent implements OnInit, OnDestroy {

  @Input() warehouseProduct: Observable<WarehouseProduct>;
  @Output() modifyClicked = new EventEmitter<void>();
  @ViewChild('imageSelect') imageSelect: ElementRef;

  warehouseProductObject?: WarehouseProduct;
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;
  imgCnt = 0;
  imageSelectControl: FormControl;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private warehouseService: WarehouseService,
    private snack: MatSnackBar,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.imageSelectControl = this.fb.control('');
  }

  ngOnInit(): void {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });

    this.warehouseProduct
      .pipe(takeUntil(this.destroyed$))
      .subscribe((warehouseProduct: WarehouseProduct) => {
        this.warehouseProductObject = warehouseProduct;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć produkt?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.warehouseService.deleteProduct(this.warehouseProductObject.uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto produkt', '', {duration: 2000});
              this.router.navigate(['/stan-magazynowy']);
            },
            error: (response: HttpErrorResponse) => {
              this.snack.open(response.error.error.text, response.status.toString(), {duration: 3000});
            }
          });
      }
    });
  }
}
